// helper.ts
import * as Yup from "yup";

// --- Table structure for course list (if needed later) ---


// --- Type for course form ---
export type Course = {
  course_name: string;
  gcf_public_course_id?: string;
  npractice_practice_program_id?: string;
  display_name?: string;
  image_url?: string;
  status?: string;
};

// --- Initial values for form ---
export const courseInitialValues: Course = {
  course_name: "",
  gcf_public_course_id: "",
  npractice_practice_program_id:"",
  display_name:"",
  image_url:"",
  status:"ACTIVE"
};

// --- Mandatory fields for validation ---
export const courseMandatoryFields = [
  { id: "course_name" },
  // { id: "gcf_public_course_id" },
];

// --- Yup validation schema ---
export const courseValidationSchema = Yup.object().shape({
  course_name: Yup.string().required("Course name is required"),
  // gcf_public_course_id: Yup.string().required("Course ID is required"),
});

// --- Fields for DynamicForm ---
export const createCourseProperties = [
  {
    id: "course_name",
    type: "text",
    label: "Course Name",
    placeholder: "Enter course name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "display_name",
    type: "text",
    label: "Display Name",
    placeholder: "Enter Display Name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    required: false,
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    hideNone: true,
  },
];

// ✅ Separate preview-only fields
export const previewCourseProperties = [
  ...createCourseProperties,
  {
    id: "gcf_public_course_id",
    type: "text",
    label: "GCF Public Course ID",
    placeholder: "Enter GCF Public Course ID",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    readOnly: true,
  },
  {
    id: "npractice_practice_program_id",
    type: "text",
    label: "nPractice Practice Program ID",
    placeholder: "Enter nPractice Practice Program ID",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    readOnly: true,
  },
];

// export const updateCourseProperties = [
//   {
//     id: "course_name",
//     type: "text",
//     label: "Course Name",
//     placeholder: "Enter course name",
//     required: true,
//   },
// ];

export const table = {
  primaryData: [
    {
      title: "Name",
      value: "course_name",
      type: "configue",
    },
    {
      title: "status",
      value: "status",
    },
    {
      title: "CreatedBy",
      value: "created_by_name",
      type: "configue",
    },
    {
      title: "CreatedAt",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendIsArchived: true,
    },
  ],
  secondaryData: [],
};
